const PAGINATION_SIZE = 7

export default PAGINATION_SIZE